/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { ROOT_URL_V2 } from '../../../config';
import { fetchLoggedInAsync } from '../../../actions/ClientData';
import history from '../../../history';

class AutoLogin extends Component {
    componentDidMount() {
        const { loggedIn, dispatch } = this.props;
        const urlParams = new URLSearchParams(history.location.search);
        const token = urlParams.get('token');
        const redirectUrl = decodeURI(urlParams.get('redirect'));

        if (loggedIn) {
            this.redirect(redirectUrl);
            return null;
        }

        if (token) {
            const self = this;
            axios({
                method: 'GET',
                url: `${ROOT_URL_V2}user/login/`,
                headers: { Authorization: `Token ${token}` },
            })
                .then(response => {
                    dispatch(
                        fetchLoggedInAsync((resp, error) => {
                            if (error) history.push('/');
                            else self.redirect(redirectUrl);
                        }),
                    );
                })
                .catch(err => {
                    self.redirect(redirectUrl);
                });
        } else {
            this.redirect();
        }
    }

    redirect(redirectUrl) {
        if (redirectUrl) {
            if (redirectUrl.includes('checkout')) {
                history.push({
                    pathname: redirectUrl,
                    state: { mode: 'checkout' },
                });
            } else {
                history.push(redirectUrl);
            }
        } else {
            history.push('/');
        }
    }

    render() {
        return (
            <div className="initial-loading">
                <i className="icon icon-loading-1" />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loggedIn: state.user.loggedIn,
    };
}

export default withRouter(connect(mapStateToProps)(AutoLogin));
